import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export const useInbox = () =>
  useQuery({
    queryKey: ["inbox"],
    queryFn: () => api.inbox.list(),
    refetchInterval: 2 * 60_000,
    staleTime: 60_000,
  });
